import { render } from "./contratantes.vue?vue&type=template&id=63516f32&scoped=true"
import script from "./contratantes.vue?vue&type=script&lang=js"
export * from "./contratantes.vue?vue&type=script&lang=js"

import "./contratantes.vue?vue&type=style&index=0&id=63516f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63516f32"]])

export default __exports__